import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'

// import other components within the same project here

import Localization from "../../Localization.jsx"

import LocaleDetailView from "../../views/locale/LocaleDetailView.jsx"

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stepper,
  Step,
  StepLabel,
  Button,
} from '@material-ui/core';

class CreateLocaleDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
      activeStep: 0,
    };
    autoBind(this);
  }

  changeActiveStep(index) {
    this.setState({ activeStep: index });
    this.state.activeStep = index;
    this.refs.localeDetailView.changeActiveView(index);
  }

  handleEnter() {
    this.changeActiveStep(0);
  }

  close() {
    this.setState({ open: false });
    this.state.open = false;
  }

  handleClose() {
    if (this.refs.localeDetailView.state.isDirty) {
      let dialogText = {
        title: Localization.strings.UNSAVED_CHANGES,
        content: Localization.strings.UNSAVED_REMINDER,
        confirm: Localization.strings.CONTINUE_EDITING,
        cancel: Localization.strings.DISCARD_CHANGES,
      }
      this.props.root.refs.confirmDialog.show(dialogText, this.closeCancelClicked, this.closeConfirmClicked);
    }
    else {
      this.close();
    }
  }

  closeCancelClicked() {

  }

  closeConfirmClicked() {
    this.close();
  }

  handleNext = () => {
    if (this.refs.localeDetailView.validateInput()) {
      let steps = this.props.parent.getSteps();
      let i = this.state.activeStep + 1;
      if (i === steps.length) {
        i = steps.length - 1;
      }
      this.changeActiveStep(i);
    }
  };

  handleBack() {
    let i = this.state.activeStep - 1;
    if (i < 0) {
      i = 0;
    }
    this.changeActiveStep(i);
  };

  handleCancel () {
    this.handleClose();
  }

  handleFinish () {
    if (this.refs.localeDetailView.validateInput()) {
      let localeDetailViewState = this.refs.localeDetailView.state;
      let requestObj = {
        locale_name: localeDetailViewState.localeName.trim(),
        description: localeDetailViewState.localeDesc.trim(),
        is_ready: (localeDetailViewState.localePublish? 1 : 0),
        is_share: (localeDetailViewState.localeShareable? 1 : 0),
        is_manual_play: (localeDetailViewState.localeManualPlay? 1 : 0),
        tn_file_id: localeDetailViewState.localeCoverFileID,
        intro_file_id: localeDetailViewState.localeCoverFileID,
        kla: localeDetailViewState.localeKLA,
        subject: 1,
        color: 0,
        lang: "tc",
        user_id: this.props.root.getMyUserId(),
        school_id: this.props.root.getMySchoolId(),
      }
      this.props.root.refs.API.request("create_locale", requestObj, this.createLocaleOK, this.createLocaleFailed);
    }
  }

  createLocaleOK(res) {
    this.handleClose();
    this.props.parent.refreshLocaleList();
  }

  createLocaleFail(err) {
    console.log("create locale failed");
  }

  render() {
    const steps = this.props.parent.getSteps();

    return (
      <div>
        <Dialog
          open={this.state.open}
          fullWidth={true}
          maxWidth={'md'}
          onClose={this.handleClose}
          onEnter={this.handleEnter}
        >
          <DialogTitle>
            {Localization.strings.NEW_VITALS}
          </DialogTitle>
          <DialogContent>
            <Stepper activeStep={this.state.activeStep}>
              {steps.map((label, index) => {
                return (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>

            <LocaleDetailView root={this.props.root} parent={this} ref="localeDetailView"
              locale_name = ""
              description = ""
              is_ready = {0}
              is_share = {0}
              is_manual_play = {0}
            />
          </DialogContent>
          <DialogActions style={{padding:'16px 24px'}}>
            <If condition={this.state.activeStep === 0}>
              <Then>
                <Button
                  onClick={this.handleCancel}
                >
                  {Localization.strings.CANCEL}
                </Button>
              </Then>
              <Else>
                <Button
                  onClick={this.handleBack}
                >
                  {Localization.strings.BACK}
                </Button>
              </Else>
            </If>
            <If condition={this.state.activeStep === steps.length - 1}>
              <Then>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handleFinish}
                >
                  {Localization.strings.FINISH}
                </Button>
              </Then>
              <Else>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handleNext}
                >
                  {Localization.strings.NEXT}
                </Button>
              </Else>
            </If>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default CreateLocaleDialog;
